import React from "react";
import { useTranslation } from "react-i18next";
import { Star, BadgeCheck } from "lucide-react";

const Testimonials = () => {
  const { t } = useTranslation();
  const all = t("testimonials.items", { returnObjects: true }) || [];
  const items = all.slice(0, 3);
  const verifiedLabel = t("testimonials.verified");

  return (
    <section className="section bg-white" data-testid="testimonials-section">
      <div className="container-x">
        <div className="max-w-3xl mb-12">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">
            {t("testimonials.title")}
          </p>
          <h2 className="mt-2 font-heading font-extrabold tracking-tighter text-3xl sm:text-4xl text-slate-900">
            {t("testimonials.subtitle")}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it, idx) => (
            <div
              key={idx}
              className="flex flex-col"
              data-testid={`testimonial-${idx}`}
            >
              {/* Photo hero-style */}
              {it.photo && (
                <div className="relative">
                  <div className="absolute -inset-2 rounded-[28px] bg-gradient-to-tr from-emerald-200/60 to-sky-200/60 blur-xl" />
                  <div className="relative rounded-3xl overflow-hidden ring-1 ring-slate-200 shadow-xl">
                    <img
                      src={it.photo}
                      alt={it.service}
                      className="w-full h-64 object-cover object-center"
                      loading="lazy"
                    />
                    {/* Badge service sur la photo */}
                    {it.service && (
                      <div className="absolute bottom-3 left-3 right-3">
                        <span className="inline-block rounded-full bg-white/90 backdrop-blur-sm px-3 py-1 text-xs font-semibold text-brand-green border border-white/60 shadow">
                          {it.service}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Contenu */}
              <div className="mt-5 flex flex-col flex-1">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-1 text-amber-400">
                    {[0, 1, 2, 3, 4].map((s) => (
                      <Star key={s} className="h-4 w-4 fill-current" />
                    ))}
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-brand-green">
                    <BadgeCheck className="h-3.5 w-3.5" />
                    {verifiedLabel}
                  </span>
                </div>

                {(it.name || it.role) && (
                  <div className="mb-3">
                    {it.name && (
                      <span className="font-heading font-semibold text-slate-900 text-sm">{it.name}</span>
                    )}
                    {it.role && (
                      <span className="text-slate-500 text-xs ml-2">-{it.role}</span>
                    )}
                  </div>
                )}

                <p className="text-slate-700 leading-relaxed text-sm flex-1">
                  "{it.text}"
                </p>

                {it.date && (
                  <div className="mt-4 pt-4 border-t border-slate-100">
                    <div className="text-xs text-slate-400">{it.date}</div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-slate-400">
          {t("testimonials.gmb_notice")}
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
